import { Component } from '@angular/core';
import {HeroFarmaciaComponent} from "../hero-farmacia/hero-farmacia.component";
import {InfoFarmaciaComponent} from "../info-farmacia/info-farmacia.component";
import {NavBarComponent} from "../../nav-bar/nav-bar.component";
import {FooterPersonaComponent} from "../../footer-persona/footer-persona.component";

@Component({
  selector: 'app-all-farmacia',
  standalone: true,
  imports: [
    HeroFarmaciaComponent,
    InfoFarmaciaComponent,
    NavBarComponent,
    FooterPersonaComponent
  ],
  templateUrl: './all-farmacia.component.html',
  styleUrl: './all-farmacia.component.css'
})
export class AllFarmaciaComponent {

}
